import useFormatCurrencyForItinerary from '@/src/hooks/currency/useFormatCurrencyForItinerary'
import useFareCards from '@/src/hooks/itinerary/useFareCards'
import { Divider } from '@mui/material'
import { useTranslations } from 'next-intl'
import VasForFareFamily from './vasForFareFamily'

const VasForFareFamilyWrapper = () => {
    const { faresToDisplay, onFareSelect, formatFareTitle, fareFamilyEnabledOnReview } = useFareCards()
    const { formatCurrency } = useFormatCurrencyForItinerary()
    const t = useTranslations('common')

    if (!fareFamilyEnabledOnReview || !Array.isArray(faresToDisplay) || !faresToDisplay.length) {
        return null
    }

    return (
        <>
            <Divider sx={{ mt: { xs: 0, lg: 3 }, mb: { xs: 0, lg: 2 }, display: { xs: 'none', lg: 'block' } }} />
            <VasForFareFamily
                fares={faresToDisplay}
                onFareSelect={onFareSelect}
                formatFareTitle={formatFareTitle}
                formatCurrency={formatCurrency}
                t={t}
            />
        </>
    )
}

export default VasForFareFamilyWrapper
